import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Box } from '@hover/blueprint';
import { animated } from 'react-spring';

const MainContainer = styled(animated.div)`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100vw;
  height: 100%;
  overflow: hidden;
`;

const preventOverscrollStyle = css`
  body {
    position: fixed;
    overscroll-behavior-y: none;
  }
`;

const AnimatedContainer = styled(animated.div)`
  pointer-events: none;
`;

const DesignStudioContainer = styled(Box)`
  overflow: hidden;
`;

export {
  AnimatedContainer,
  DesignStudioContainer,
  MainContainer,
  preventOverscrollStyle,
};
